import { gql } from "@apollo/client";

// Note: $input.categoryFilter (optional) — when set to a value other than
// "all", BE returns a live DDB query for that ticketId prefix instead of
// the snapshot. Lets us browse categories that aren't in the recent-20 snapshot.
export const GET_CONTENT_FEED_QUERY = gql`
  query GetContentFeed($input: GetContentFeedInput!) {
    getContentFeed(input: $input) {
      items {
        ticketId
        createdAt
        title
        oneLiner
        keyMomentsCount
        keywords
      }
      generatedAt
      totalItems
      nextToken
    }
  }
`;

export const SEARCH_CONTENT_FEED_QUERY = gql`
  query SearchContentFeed($input: SearchContentFeedInput!) {
    searchContentFeed(input: $input) {
      items {
        ticketId
        createdAt
        title
        oneLiner
        keyMomentsCount
        keywords
      }
      generatedAt
      totalItems
    }
  }
`;

export const REFRESH_CONTENT_FEED_MUTATION = gql`
  mutation RefreshContentFeed($input: RefreshContentFeedInput!) {
    refreshContentFeed(input: $input) {
      requestId
      status
      message
    }
  }
`;
